module.exports = __webpack_public_path__ + "img/fusion.3668623d.png";